import React, { useState } from "react";
import Card from "../../../../../components/ui/Card";
import Button from "../../../../../components/ui/Button";
import { Copy, CheckCircle } from "lucide-react";

const PlatformDealsSection = ({ deals, onActivateDeal }) => {
  const [copiedId, setCopiedId] = useState(null);

  const handleCopy = (textToCopy, dealId) => {
    navigator.clipboard.writeText(textToCopy);
    setCopiedId(dealId);
    setTimeout(() => setCopiedId(null), 2000); // Reset after 2 seconds
  };

  return (
    <div>
      <h3 className="text-lg font-semibold text-slate-800 mb-4">
        Available Platform Deals
      </h3>
      <p className="text-sm text-slate-500 mb-6">
        Activate these official Adnaki-vetted affiliate and referral programs to
        create new revenue streams. All tracking and payouts are managed
        automatically.
      </p>
      <div className="grid grid-cols-1 @md:grid-cols-2 @lg:grid-cols-3 gap-6">
        {deals.map((deal) => (
          <Card key={deal.id} className="flex flex-col">
            <div className="flex items-center mb-3">
              <img
                src={deal.logoUrl}
                alt={`${deal.brand} logo`}
                className="w-10 h-10 rounded-full mr-4"
              />
              <div>
                <p className="font-semibold text-slate-800">{deal.brand}</p>
                <p className="text-xs text-slate-500">{deal.type}</p>
              </div>
            </div>
            <p className="text-sm text-slate-600 flex-grow">{deal.offer}</p>
            <div className="mt-4">
              {deal.isActivated ? (
                // ✨ FIX STARTS HERE ✨
                <div className="border border-slate-200 bg-slate-50 rounded-md flex items-center justify-between pl-3 pr-2 py-1.5">
                  <span className="text-primary font-mono text-sm truncate mr-2">
                    {deal.creatorLink || deal.creatorCode}
                  </span>
                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={() =>
                      handleCopy(deal.creatorLink || deal.creatorCode, deal.id)
                    }
                    className="px-2 flex-shrink-0"
                  >
                    {copiedId === deal.id ? (
                      <CheckCircle size={16} className="text-green-500" />
                    ) : (
                      <Copy size={16} className="text-slate-500" />
                    )}
                  </Button>
                </div>
              ) : (
                // ✨ FIX ENDS HERE ✨
                <Button
                  variant="primary"
                  className="w-full"
                  onClick={() => onActivateDeal(deal.id)}
                >
                  Activate Deal
                </Button>
              )}
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default PlatformDealsSection;
